module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01.adc4562f0b085a42c0f86f12f0ccbec9.png";